import {
  Container,
  Grid,
  Typography,
  Button,
  Box,
  TextField,
  Stack,
} from "@mui/material";
import { FormControl } from "@mui/material";
import { MdPhone, MdEmail, MdLocationPin } from "react-icons/md";
import { BsGithub } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";

import styled from "styled-components";

const OpenPDFNew = (url) => {
  window.open(url, "_blank");
};

export default function Contact() {
  return (
    <Container
      maxWidth="lg"
      sx={{ textAlign: "center" }}
      id="contact"
      className="nav-link contact"
    >
      <Typography
        variant="h4"
        color="black"
        style={{ fontFamily: "Great Vibes", color: "#1b242f" }}
      >
        Contacts
      </Typography>
      <div
        style={{
          width: "3rem",
          backgroundColor: "#1b242f",
          height: "1vh",
          margin: "auto",
          marginBottom: "2%",
        }}
        data-aos="fade-left"
      ></div>
      <DIV>
        <Grid
          container
          spacing={1}
          style={{
            margin: "2%",
            marginTop: "5%",
            marginBottom: "4%",
            textAlign: "center",
            placeItems: "center",
            width: "100%",
            border: "0.5px ",
            boxShadow:
              "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
            borderRadius: "15px",
            backgroundImage: "url(./lightCors.gif)",
            backgroundRepeat: "no-repeat",
            objectFit: "contain",
            backgroundSize: "115% 110%",
            color: "black",
            opacity: "1.5",
          }}
          data-aos="zoom-in"
        >
          <Stack direction="row" alignItems="center" justifyContent="center">
            <MdPhone size="5%" />
            <Typography
              id="contact-phone"
              sx={{
                fontSize: { xs: "22px", sm: "30px", md: "35px" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                opacity: "5",
              }}
            >
              +7349554782
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <MdLocationPin size="5%" />
            <Typography
              sx={{
                fontSize: { xs: "22px", sm: "30px", md: "35px" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                opacity: "5",
              }}
            >
              : Bengaluru, Karnataka
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <MdEmail size="5%" />
            <Typography
              id="contact-email"
              sx={{
                fontSize: { xs: "22px", sm: "30px", md: "35px" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                opacity: "5",
              }}
            >
              : tathagatraj4@gmail.com
            </Typography>
          </Stack>
        </Grid>
        <Grid
          container
          spacing={1}
          style={{ margin: "2%", marginTop: "5%", marginBottom: "4%" }}
          justifyContent="center"
        >
          <Button
            className="my-typography-button"
            variant="contained"
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "black",
              borderRadius: "10px",
              margin: "2%",
              fontFamily: "Raleway",
              boxShadow:
                "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
              borderRadius: "15px",
              backgroundImage: "url(./greenStarTravel.gif)",
              backgroundRepeat: "no-repeat",
              objectFit: "contain",
              backgroundSize: "100% 100%",
              color: "whitesmoke",
              opacity: "0.9",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
            size="large"
            startIcon={<BsGithub size={42} />}
            id="contact-github"
            onClick={() => OpenPDFNew("https://github.com/Tathagat017")}
          >
            GITHUB
          </Button>
          <Button
            className="my-typography-button"
            variant="contained"
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "black",
              borderRadius: "10px",
              margin: "2%",
              fontFamily: "Raleway",
              boxShadow:
                "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
              borderRadius: "15px",
              backgroundImage: "url(./greenStarTravel.gif)",
              backgroundRepeat: "no-repeat",
              objectFit: "contain",
              backgroundSize: "100% 100%",
              color: "whitesmoke",
              opacity: "0.9",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
            size="large"
            startIcon={<FaLinkedin size={42} />}
            href="https://www.linkedin.com/in/tathagat-tathagat/"
            id="contact-linkedin"
            onClick={() =>
              OpenPDFNew("https://www.linkedin.com/in/tathagat-tathagat/")
            }
          >
            LINKEDIN
          </Button>
          <Button
            className="my-typography-button"
            variant="contained"
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              color: "black",
              margin: "2%",
              fontFamily: "Raleway",
              boxShadow:
                "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
              borderRadius: "15px",
              backgroundImage: "url(./greenStarTravel.gif)",
              backgroundRepeat: "no-repeat",
              objectFit: "contain",
              backgroundSize: "100% 100%",
              color: "whitesmoke",
              opacity: "0.9",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
            size="large"
            startIcon={<MdEmail size={42} />}
            onClick={() =>
              OpenPDFNew(
                "https://mail.google.com/mail/?view=cm&source=mailto&to=tathagatraj4@gmail.com"
              )
            }
          >
            Email
          </Button>
        </Grid>
        <Box width={"100%"} p={2}>
          <form
            action="https://getform.io/f/202a8738-e183-44eb-8339-58e381c71c26"
            method="POST"
          >
            <TextField
              name="name"
              label="Name"
              variant="outlined"
              fullWidth
              margin="normal"
            />
            <TextField
              name="email"
              label="Email"
              variant="outlined"
              fullWidth
              margin="normal"
            />
            <TextField
              name="message"
              label="Message"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              margin="normal"
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "black",

                fontFamily: "Raleway",
              }}
              sx={{
                borderRadius: "3rem",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
              size="large"
              startIcon={<MdEmail />}
            >
              Send Message
            </Button>
          </form>
        </Box>
      </DIV>
    </Container>
  );
}

const DIV = styled.div`
  text-align: center;
`;
// make this responsive till galaxy fold resolution
